export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14108.e2cf6520.jpg";